import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.Camion;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
    onGuardar: () => Promise<void>;
    nuevo: boolean;
}

/**
* Valida un Camion
*/
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        IdConfigAutotransporte : validation.required,
        IdTipoPermiso: validation.required
    };
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
export class CamionFormNoRx extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    render() {
        const { value, onGuardar, nuevo } = this.props;
        const getField = this.getField;

        const hasError = this.hasError(this.props);
        const Text = getField(kea.Text);
        const Number = getField(kea.Number);
        const Ruta = getField(selectores.Ruta);
        const CpSatTipoPermisoSelector = getField(selectores.CpSatTipoPermisoSelector);
        const CpSatConfigAutotransporte = getField(selectores.CpSatConfigAutotransporteSelector);
        const ParteTransporte = getField(selectores.ParteTransporte);

        return (
            <div>
                <kea.Title titulo="Camión de ruta" onRegresar={() => history.go("/catalogos/Camion")} />
                {kea.autogrid(6, [
                    <Text field="Nombre" />,
                    <Ruta field="IdRuta" label="Ruta" />,
                    <Text field="Placa" />,
                    <Text field="Marca" />,
                    <Text field="Modelo" />,
                    <Number field="Year" label="Año" format="int" />,
                    <Text field="Aseguradora" label="Nombre de la aseguradora" />,
                    <Text field="NumeroPoliza" label="Número de la poliza del seguro" />,
                    <CpSatTipoPermisoSelector field="IdTipoPermiso" label="Tipo Permiso Sat" />,
                    <Text field="PermisoSCT" label="Número de Permiso SCT" />,
                    <CpSatConfigAutotransporte field="IdConfigAutotransporte" label="Tipo de autotransporte" />,
                    <Number field="Peso" label="Peso (Ton)" />
                    
                ])}

                {kea.autogrid(4, [
                    <label>Datos Propietario</label>
                ])}
                {kea.autogrid(4, [
                    <Text field="Propietario_Nombre" />,
                    <Text field="Propietario_Rfc" />,
                    <ParteTransporte field="Propietario_parteTransporte"/>
                    
                ])}


                {kea.autogrid(4, [
                    <label>Datos Arrendador</label>
                ])}
                {kea.autogrid(4, [
                    <Text field="Arrendador_Nombre" />,
                    <Text field="Arrendador_Rfc" />,
                    <ParteTransporte field="Arrendador_parteTransporte"/>
                ])}     

                <div className="row">
                    <div className="col-md-12">
                        <kea.GuardarButton onClick={onGuardar} disabled={hasError} />
                    </div>
                </div>
            </div>);
    }
}

export const CamionForm = componentToRx(CamionFormNoRx);



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/camion/edit/form.tsx